import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider} from "./services/AuthService";
import App from "./App";
import AppProvider from "./components/AppProvider";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthProvider>
        <AppProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </AppProvider>
    </AuthProvider>
);